// libs
import React, { memo, useCallback, useState } from 'react';

// components
import Collapsible from 'shared/components/Collapsible';
import CollapsibleHeader from 'shared/layouts/DetailsPage/components/ProductInfo/components/CollapsibleHeader';
import CollapsibleExpander from 'shared/layouts/DetailsPage/components/ProductInfo/components/CollapsibleHeader/CollapsibleExpander';
import CollapsibleContent from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/components/CollapsibleContent';
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import { useEligibleSSRVariantName } from 'shared/components/ExperimentV2/helpers';
import {
  MULTI_SELLER_EXPERIMENT_ID,
  MULTI_SELLER_TREATMENT_VARIANT,
} from 'shared/constants/multiSeller';

interface IDescriptionRow {
  widget: IWidget;
}
function DescriptionRow({ widget }: IDescriptionRow) {
  const [isExpanded, setIsExpanded] = useState(false);
  const multiSellerEnabled = useRemoteConfig('multiSellerEnabled', false);
  const multiSellerConfig = useRemoteConfig('multiSeller');
  const { isEligible, variant } = useEligibleSSRVariantName(MULTI_SELLER_EXPERIMENT_ID);
  const shouldHideVendorDetails =
    multiSellerEnabled &&
    multiSellerConfig?.enabled &&
    multiSellerConfig?.pdp?.enabled &&
    isEligible &&
    variant === MULTI_SELLER_TREATMENT_VARIANT;

  const onChange = useCallback((expanded: boolean) => {
    setIsExpanded(expanded);
  }, []);

  if (widget.title === 'Vendor details' && shouldHideVendorDetails) {
    return null;
  }

  return (
    <Collapsible
      className="collapsible"
      CustomExpander={CollapsibleExpander}
      header={
        <CollapsibleHeader
          title={widget.title}
          subtitle={widget.subtitle ? widget.subtitle : ''}
          isExpanded={isExpanded}
          iconName={widget.iconName ? widget.iconName : ''}
        />
      }
      onChange={onChange}
    >
      <CollapsibleContent widget={widget}></CollapsibleContent>
    </Collapsible>
  );
}

export default memo(DescriptionRow);
